<template>
    <div class="row">
        <div v-if="users.length == 0" class="row">
            <div class="col-12 col-sm-10 col-md-8 col-lg-10 mx-auto text-center">
                <p>
                    Nessuno utente trovato.
                </p>
            </div>
        </div>
        <div v-else v-for="user in users" :key="user.id" class="col-12 col-md-6 col-lg-4 mb-4">
            <a :href="'/structure/student/StudentBaseAction?userId=' + user.user_id" class="nome-card">
                <div class="card-body p-4 text-center border-bottom">
                    <img :src="'/assets/img/avatars/student/' + user.avatar + '.png'" alt="" class="rounded-circle mb-0" width="130" height="130" />
                </div>
                <ul class="px-2 py-2 bg-light list-unstyled d-flex align-items-center justify-content-center mb-0">
                    <li class="position-relative">
                        <h5 class="fw-semibold mb-0">{{ user.name }} {{ user.surname }}</h5>
                    </li>
                </ul>
            </a>
        </div>
    </div>
</template>
<script>

export default{
    props: {
        users: {
            type: Array,
            required: true
        }
    }
}

</script>